import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279 } from '~/src/styles/tokens/break-points';
import { PhoneField } from '~/src/components/common-components/phone-field/phone-field';
import { EmailField } from '~/src/components/common-components/email-field/email-field';
import { FioField } from '~/src/components/common-components/fio-field/fio-field';
import { InnField } from '~/src/components/common-components/inn-field/inn-field';

const CommonFieldStyles = css`
    width: 100%;
`;

export const PersonContactsWrapper = styled.div`
    width: 100%;
    gap: ${rem(24)};
    flex-direction: column;
`;

export const PersonContactsContentContainer = styled.div`
    width: 100%;
    gap: ${rem(32)};
    flex-wrap: nowrap;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            flex-direction: column;
            gap: ${rem(24)};
        `,
    )};
`;

export const PhoneEmailContainer = styled.div`
    width: 100%;
    gap: ${rem(32)};
    flex-wrap: nowrap;

    ${mediaQuery({ maxWidth: MAX_1279 },
        css`
            flex-direction: column;
            gap: ${rem(24)};
      `,
    )};
`;

export const EmailTextbox = styled(EmailField)`
    ${CommonFieldStyles};
`;

export const PhoneTextbox = styled(PhoneField)`
    ${CommonFieldStyles};
`;

export const FioTextbox = styled(FioField)`
    ${CommonFieldStyles};
`;

export const InnTextbox = styled(InnField)`
    ${CommonFieldStyles};
`;

